var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMdf(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsDc: "http://purl.org/dc/elements/1.1/",
    xmlnsCc: "http://creativecommons.org/ns#",
    xmlnsRdf: "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 56 56",
    style: {
      enableBackground: "new 0 0 56 56"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e9e9e0"
    },
    d: "M36.985,0H7.963C7.155,0,6.5,0.655,6.5,1.926V55c0,0.345,0.655,1,1.463,1h40.074 c0.808,0,1.463-0.655,1.463-1V12.978c0-0.696-0.093-0.92-0.257-1.085L37.607,0.257C37.442,0.093,37.218,0,36.985,0z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#d9d7ca"
    },
    points: "37.5,0.151 37.5,12 49.349,12"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#556080",
      fillOpacity: 1
    },
    d: "M48.037,56H7.963C7.155,56,6.5,55.345,6.5,54.537V39h43v15.537C49.5,55.345,48.845,56,48.037,56z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#c8bdb8"
    },
    cx: 27.5,
    cy: 21,
    r: 12
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#e9e9e0"
    },
    cx: 27.5,
    cy: 21,
    r: 3
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d3ccc9"
    },
    d: "M25.379,18.879c0.132-0.132,0.276-0.245,0.425-0.347l-2.361-8.813 c-1.615,0.579-3.134,1.503-4.427,2.796c-1.294,1.293-2.217,2.812-2.796,4.427l8.813,2.361 C25.134,19.155,25.247,19.011,25.379,18.879z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d3ccc9"
    },
    d: "M30.071,23.486l2.273,8.483c1.32-0.582,2.56-1.402,3.641-2.484c1.253-1.253,2.16-2.717,2.743-4.275 l-8.188-2.194C30.255,22.939,29.994,23.2,30.071,23.486z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 400,
      fontStretch: "normal",
      fontSize: "13.75px",
      fontFamily: "Allerta",
      InkscapeFontSpecification: "Allerta",
      letterSpacing: ".15000001px",
      fill: "#fff",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 21.256983,42.95969 1.638183,0 0,9.89624 -1.638183,0 0,-6.807861 -2.215576,5.505371 -1.42334,0 -2.229004,-5.505371 0,6.807861 -1.638184,0 0,-9.89624 1.638184,0 2.940674,6.767578 2.927246,-6.767578 z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 33.57251,47.632542 q 0,1.221923 -0.268555,2.094726 -0.255127,0.859375 -0.657959,1.450196 -0.402832,0.577392 -0.913086,0.913085 -0.496826,0.335694 -0.966797,0.510254 -0.46997,0.161133 -0.859375,0.214844 -0.389404,0.04028 -0.577392,0.04028 l -3.746338,0 0,-9.89624 2.980957,0 q 1.248779,0 2.188721,0.402832 0.953369,0.389404 1.571044,1.047363 0.631104,0.657959 0.939942,1.503907 0.308838,0.832519 0.308838,1.71875 z m -4.780274,4.041748 q 1.638184,0 2.363282,-1.047364 0.725097,-1.047363 0.725097,-3.034668 0,-0.617675 -0.147705,-1.221923 -0.147705,-0.604248 -0.577392,-1.087647 -0.41626,-0.496826 -1.141358,-0.792236 -0.725098,-0.308838 -1.879883,-0.308838 l -0.939941,0 0,7.492676 1.5979,0 z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 37.697119,44.181614 0,3.115234 4.135742,0 0,1.101075 -4.135742,0 0,4.458007 -1.638184,0 0,-9.89624 6.190186,0 0,1.221924 -4.552002,0 z",
    style: {
      fill: "#fff"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMdf);
export default __webpack_public_path__ + "static/media/mdf.a6b89adb6686e68700694468478c4c0f.svg";
export { ForwardRef as ReactComponent };